import { Container } from 'inversify';
import { VideoMakerApi } from '../services/VideoMakerApi/VideoMakerApi';
import { VideoMakerJobQueue } from '../services/VideoMakerApi/VideoMakerJobQueue';
import { getBaseUrl } from '../utils/getBaseUrl';
import { poller } from '../utils/poller/poller';
import { apiServices } from './services';
export var container = new Container();
container.bind(apiServices.videoMakerBaseUrl).toConstantValue(getBaseUrl());
container.bind(apiServices.videoMakerApi).to(VideoMakerApi);
container
    .bind(apiServices.videoMakerJobQueue)
    .to(VideoMakerJobQueue);
container.bind(apiServices.poller).toConstantValue(poller);
//# sourceMappingURL=ioc.config.js.map